import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GLOBAL } from './global';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root', // Modern way to provide the service
})
export class FolderCompanyService {
  public url: string;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url;
  }

  create(token, task): Observable<any> {
    const json = JSON.stringify(task);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });
    return this._http
      .post(`${this.url}/foldercompany/new`, params, { headers })
      .pipe(map((res: any) => res));
  }

  getFolders(token, page = 1, type): Observable<any> {
  const params = `authorization=${token}`;
  const headers = new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Requested-With': 'XMLHttpRequest',
  });
  return this._http
    .post(`${this.url}/foldercompany/list?page=${page}&type=${type}`, params, { headers })
    .pipe(map((res: any) => res));
}

getSubFolders(token, page = 1, type, parent): Observable<any> {
  const params = `authorization=${token}`;
  const headers = new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Requested-With': 'XMLHttpRequest',
  });
  return this._http
    .post(`${this.url}/foldercompany/list?page=${page}&type=${type}&parent=${parent}`, params, { headers })
    .pipe(map((res: any) => res));
}

getFolder(token, id): Observable<any> {
  const params = `authorization=${token}`;
  const headers = new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Requested-With': 'XMLHttpRequest',
  });
  const page = 1;
  return this._http
    .post(`${this.url}/foldercompany/detail/${id}?page=${page}`, params, { headers })
    .pipe(map((res: any) => res));
}

update(token, task, id): Observable<any> {
  const json = JSON.stringify(task);
  const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
  const headers = new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Requested-With': 'XMLHttpRequest',
  });
  const page = 1;
  return this._http
    .post(`${this.url}/foldercompany/edit/${id}?page=${page}`, params, { headers })
    .pipe(map((res: any) => res));
}

search(token, search = null, filter = null, order = null): Observable<any> {
  const params = `authorization=${token}&filter=${filter}&order=${order}`;
  const headers = new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Requested-With': 'XMLHttpRequest',
  });
  const page = 1;
  let url: string;
  if (search == null) {
    url = `${this.url}/foldercompany/search?page=${page}`;
  } else {
    url = `${this.url}/foldercompany/search/${search}?page=${page}`;
  }
  
  return this._http
    .post(url, params, { headers })
    .pipe(map((res: any) => res));
}

deleteFolder(token, id): Observable<any> {
  const params = `authorization=${token}`;
  const headers = new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Requested-With': 'XMLHttpRequest',
  });
  const page = 1;
  return this._http
    .post(`${this.url}/foldercompany/remove/${id}?page=${page}`, params, { headers })
    .pipe(map((res: any) => res));
}


  
}
